import { AppContext } from "@lightspeed-invoicing/core-client/frontend";
import moment from "moment-timezone";
import React, { Component } from 'react';
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FormattedMessage, injectIntl } from 'react-intl';
import CalendarSelect from "../calendar/calendarselect.component.jsx";
import Icon from "../common/icon/icon.component.jsx";
import "./calendareventdatepickers.scss";
class CalendarEventDatePickers extends Component {

    constructor(props, context) {
        super(props, context)

        const now = moment()
        const remainder = 30 - (now.minute() % 30)
        const startAt = now.add(remainder, 'm').toDate()

        this.state = {
            calendarClassName: this.props.calendarClassName || 'col-5 mb-3 d-flex align-items-center',
            datePickerWrapperClassName: this.props.datePickerWrapperClassName || 'col-12 col-xl-6 offset-xl-1 mb-3 d-flex justify-content-xl-end',
            datePickerClassName: this.props.datePickerClassName || '',
            selectedCalendarId: this.props.selectedCalendarId || '',
            selectedCalendarLabel: this.props.selectedCalendarLabel || '',
            startAt: this.props.startAt || startAt,
            endAt: this.props.endAt || moment(startAt).add(30, 'm').toDate(),
            timezone: this.props.timezone || moment.tz.guess(),
            calendarSelectDisabled: this.props.calendarSelectDisabled || false,
            locale: AppContext.getLocale().getLanguage(),
        }

        this.onCalendarSelectionChange = this.onCalendarSelectionChange.bind(this)
        this.onStartAtChange = this.onStartAtChange.bind(this)
        this.onEndAtChange = this.onEndAtChange.bind(this)
    }

    componentDidMount() {
        if(this.state.timezone != "") {
            moment.tz.setDefault(this.state.timezone)
        }
        let localeModule = null
        try {
            localeModule = require(`date-fns/locale/${this.state.locale}`)
        } catch {
            localeModule = require(`date-fns/locale/en-US`)
        }
        registerLocale(this.state.locale, localeModule)
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.selectedCalendarId !== prevProps.selectedCalendarId) {
            this.setState({
                selectedCalendarId: this.props.selectedCalendarId,
            })
        }
        if (this.props.startAt !== prevProps.startAt || this.props.endAt !== prevProps.endAt) {
            this.setState({
                startAt: this.props.startAt,
                endAt: this.props.endAt,
            })
        }
        if (this.props.calendarSelectDisabled !== prevProps.calendarSelectDisabled) {
            this.setState({
                calendarSelectDisabled: this.props.calendarSelectDisabled,
            })
        }
    }

    isSameDay() {
        return this.state.startAt.getFullYear() === this.state.endAt.getFullYear() &&
            this.state.startAt.getMonth() === this.state.endAt.getMonth() &&
            this.state.startAt.getDay() === this.state.endAt.getDay()
    }

    onCalendarSelectionChange(selectedCalendarId, selectedCalendarLabel, selectedCalendar) {
        this.setState({
            selectedCalendarId,
            selectedCalendarLabel,
        }, () => {
            if (this.props.onCalendarChange) {
                this.props.onCalendarChange(this.state.selectedCalendarId, this.state.selectedCalendarLabel, selectedCalendar)
            }
        })
    }

    onStartAtChange(date) {
        const momentDate = moment(date)
        this.setState({
            startAt: date,
            endAt: momentDate.isBefore(moment(this.state.endAt)) ? this.state.endAt : momentDate.add(30, 'm').toDate()
        }, () => {
            if (this.props.onDateChange) {
                this.props.onDateChange(this.state.startAt, this.state.endAt)
            }
        })
    }

    onEndAtChange(date) {
        this.setState({
            endAt: date,
        }, () => {
            if (this.props.onDateChange) {
                this.props.onDateChange(this.state.startAt, this.state.endAt)
            }
        })
    }

    render() {
        const minEndAtDate = moment(this.state.startAt).add(30, 'm').toDate()
        const minTime = this.isSameDay() ?
            new Date(minEndAtDate.getFullYear(), minEndAtDate.getMonth(), minEndAtDate.getDay(), minEndAtDate.getHours(), minEndAtDate.getMinutes(), 0, 0) :
            new Date(minEndAtDate.getFullYear(), minEndAtDate.getMonth(), minEndAtDate.getDay(), 0, 0, 0, 0)
        const maxTime = new Date(this.state.startAt.getFullYear(), this.state.startAt.getMonth(), this.state.startAt.getDay(), 23, 59, 0, 0)

        return <div className={"form-row h-100"}>
            <div className={this.state.calendarClassName}>
                <Icon value="calendar-day" className={"mr-2"} size="20px" />
                <CalendarSelect
                    value={this.state.selectedCalendarId}
                    multi={false}
                    onChange={this.onCalendarSelectionChange}
                    disabled={this.state.calendarSelectDisabled}
                />
            </div>
            {this.state.selectedCalendarId &&
                <div className={this.state.datePickerWrapperClassName}>
                    <div className={'d-flex align-items-center justify-content-end w-100 mr-2 ' + this.state.datePickerClassName}>
                        <div className="d-flex">
                            <Icon value="clock" className={"mr-1"} size="20px" />
                            <label htmlFor="date" className="mb-0 mr-1">
                                <FormattedMessage
                                    id="calendar.new_event.start_date_label"
                                    defaultMessage="Start"
                                />
                            </label>
                        </div>
                        <div className="customDatePickerWidth">
                            <DatePicker
                                selected={this.state.startAt}
                                onChange={this.onStartAtChange}
                                showTimeSelect
                                timeFormat="p"
                                dateFormat="MMMM dd, yyyy, p"
                                locale={this.state.locale}
                            />
                        </div>
                    </div>
                    <div className={'d-flex align-items-center justify-content-end w-100 ' + this.state.datePickerClassName}>
                        <div className="d-flex">
                            <Icon value="clock" className={"mr-1"} size="20px" />
                            <label htmlFor="date" className="mb-0 mr-1">
                                <FormattedMessage
                                    id="calendar.new_event.end_date_label"
                                    defaultMessage="End"
                                />
                            </label>
                        </div>
                        <div className="customDatePickerWidth">
                            <DatePicker
                                selected={this.state.endAt}
                                onChange={this.onEndAtChange}
                                showTimeSelect
                                timeFormat="p"
                                dateFormat="MMMM dd, yyyy, p"
                                locale={this.state.locale}
                                minDate={this.state.startAt}
                                minTime={minTime}
                                maxTime={maxTime}
                                popperModifiers={{
                                    offset: {
                                        enabled: true,
                                        offset: "-100px, 5px"
                                    },
                                    preventOverflow: {
                                        enabled: true,
                                        escapeWithReference: false,
                                        boundariesElement: "viewport"
                                    }
                                }}
                            />
                        </div>
                    </div>
                </div>
            }
        </div>
    }
}

export default injectIntl(CalendarEventDatePickers)


// WEBPACK FOOTER //
// ./src/calendar/calendareventdatepickers.component.jsx